const PROCESS_ACTION_TYPES = {
  LOAD_PROCESS: 'process/LOAD_PROCESS',
};

export default PROCESS_ACTION_TYPES;
